<p-dialog
  [visible]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving"
  [closeOnEscape]="!saving"
  (onHide)="closed.emit()"
  [header]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
  [style]="{ width: '72rem', maxWidth: '96vw', maxHeight: '96dvh' }"
  [contentStyle]="{ maxHeight: 'none', minHeight: '0' }"
>
  <p class="text-muted">
    {{ "BUSINESS_SETTINGS.ADD_PERSON_HINT" | translate }}
    <strong>{{ businessName }}</strong>
  </p>
  <p *ngIf="loading" role="status">
    {{ "BUSINESS_SETTINGS.LOADING" | translate }}
  </p>
  <div *ngIf="errorKey" class="person-error" role="alert">
    {{ errorKey | translate }}
    <button
      *ngIf="errorKey === 'BUSINESS_SETTINGS.LOAD_PEOPLE_FAILED'"
      type="button"
      pButton
      [outlined]="true"
      (click)="loadOptions()"
    >
      {{ "BUSINESS_SETTINGS.RETRY" | translate }}
    </button>
  </div>
  <form
    id="settings-person-form"
    [formGroup]="form"
    (ngSubmit)="save()"
    class="person-form"
    [class.person-form--with-login]="form.controls.createLogin.value"
  >
    <div class="person-details">
      <div class="person-field person-full">
        <label for="settings-person-name">{{ "NAME" | translate }} *</label>
        <input
          id="settings-person-name"
          pInputText
          formControlName="name"
          autocomplete="off"
        />
      </div>
      <div class="person-field">
        <label for="settings-person-type"
          >{{ "BUSINESS_SETTINGS.EMPLOYEE_TYPE" | translate }} *</label
        >
        <div class="person-input-row">
          <p-select
            inputId="settings-person-type"
            [options]="types"
            formControlName="type"
            appendTo="body"
            [placeholder]="'SELECT' | translate"
          />
          <button
            type="button"
            class="person-add-btn"
            [disabled]="loading || saving"
            (click)="startAdd('type')"
            [attr.aria-expanded]="adding === 'type'"
            [attr.aria-label]="addLabelKey('type') | translate"
            [title]="addLabelKey('type') | translate"
          >
            <i class="pi pi-plus" aria-hidden="true"></i>
          </button>
        </div>
        <div class="person-add" *ngIf="adding === 'type'">
          <input
            pInputText
            #newOptionType
            class="person-add__input"
            [value]="newOptionName"
            (input)="newOptionName = newOptionType.value"
            (keyup.enter)="saveNewOption()"
            [placeholder]="'NAME' | translate"
            maxlength="100"
            autocomplete="off"
          />
          <button
            type="button"
            pButton
            [disabled]="!newOptionName.trim() || addingSaving"
            (click)="saveNewOption()"
          >
            {{ "SAVE" | translate }}
          </button>
          <button
            type="button"
            pButton
            [outlined]="true"
            [disabled]="addingSaving"
            (click)="cancelAdd()"
          >
            {{ "CANCEL" | translate }}
          </button>
        </div>
        <small
          class="person-add__error"
          role="alert"
          *ngIf="adding === 'type' && addErrorKey"
        >
          {{ addErrorKey | translate }}
        </small>
      </div>
      <div class="person-field">
        <label for="settings-person-position"
          >{{ "POSITION" | translate }} *</label
        >
        <div class="person-input-row">
          <p-select
            inputId="settings-person-position"
            [options]="positions"
            formControlName="position"
            appendTo="body"
            [placeholder]="'SELECT' | translate"
          />
          <button
            type="button"
            class="person-add-btn"
            [disabled]="loading || saving"
            (click)="startAdd('position')"
            [attr.aria-expanded]="adding === 'position'"
            [attr.aria-label]="addLabelKey('position') | translate"
            [title]="addLabelKey('position') | translate"
          >
            <i class="pi pi-plus" aria-hidden="true"></i>
          </button>
        </div>
        <div class="person-add" *ngIf="adding === 'position'">
          <input
            pInputText
            #newOptionPosition
            class="person-add__input"
            [value]="newOptionName"
            (input)="newOptionName = newOptionPosition.value"
            (keyup.enter)="saveNewOption()"
            [placeholder]="'NAME' | translate"
            maxlength="100"
            autocomplete="off"
          />
          <button
            type="button"
            pButton
            [disabled]="!newOptionName.trim() || addingSaving"
            (click)="saveNewOption()"
          >
            {{ "SAVE" | translate }}
          </button>
          <button
            type="button"
            pButton
            [outlined]="true"
            [disabled]="addingSaving"
            (click)="cancelAdd()"
          >
            {{ "CANCEL" | translate }}
          </button>
        </div>
        <small
          class="person-add__error"
          role="alert"
          *ngIf="adding === 'position' && addErrorKey"
        >
          {{ addErrorKey | translate }}
        </small>
      </div>
      <div class="person-field">
        <label for="settings-person-department"
          >{{ "DEPARTMENT" | translate }} *</label
        >
        <div class="person-input-row">
          <p-multiSelect
            inputId="settings-person-department"
            [options]="departments"
            optionLabel="Name"
            optionValue="Id"
            formControlName="departments"
            appendTo="body"
            [placeholder]="'SELECT' | translate"
          />
          <button
            type="button"
            class="person-add-btn"
            [disabled]="loading || saving"
            (click)="startAdd('department')"
            [attr.aria-expanded]="adding === 'department'"
            [attr.aria-label]="addLabelKey('department') | translate"
            [title]="addLabelKey('department') | translate"
          >
            <i class="pi pi-plus" aria-hidden="true"></i>
          </button>
        </div>
        <div class="person-add" *ngIf="adding === 'department'">
          <input
            pInputText
            #newOptionDepartment
            class="person-add__input"
            [value]="newOptionName"
            (input)="newOptionName = newOptionDepartment.value"
            (keyup.enter)="saveNewOption()"
            [placeholder]="'NAME' | translate"
            maxlength="100"
            autocomplete="off"
          />
          <button
            type="button"
            pButton
            [disabled]="!newOptionName.trim() || addingSaving"
            (click)="saveNewOption()"
          >
            {{ "SAVE" | translate }}
          </button>
          <button
            type="button"
            pButton
            [outlined]="true"
            [disabled]="addingSaving"
            (click)="cancelAdd()"
          >
            {{ "CANCEL" | translate }}
          </button>
        </div>
        <small
          class="person-add__error"
          role="alert"
          *ngIf="adding === 'department' && addErrorKey"
        >
          {{ addErrorKey | translate }}
        </small>
      </div>
      <small
        *ngIf="
          !loading &&
          (!types.length || !positions.length || !departments.length)
        "
        class="person-full"
        >{{ "BUSINESS_SETTINGS.MISSING_EMPLOYEE_OPTIONS" | translate }}</small
      >
      <div class="person-field">
        <label for="settings-person-email"
          >{{ "EMAIL" | translate }}
          <span *ngIf="form.controls.createLogin.value">*</span></label
        >
        <input
          id="settings-person-email"
          pInputText
          type="email"
          formControlName="email"
          autocomplete="off"
        />
      </div>
      <label class="kuba-choice-label person-full">
        <p-checkbox [binary]="true" formControlName="createLogin" />
        <span>{{ "BUSINESS_SETTINGS.CREATE_LOGIN" | translate }}</span>
      </label>
    </div>
    <div class="person-login" *ngIf="form.controls.createLogin.value">
      <div class="person-field">
        <label for="settings-person-username"
          >{{ "USERNAME" | translate }} *</label
        >
        <input
          id="settings-person-username"
          pInputText
          formControlName="username"
          autocomplete="off"
        />
      </div>
      <div class="person-field">
        <label for="settings-person-role">{{ "ROLE" | translate }} *</label>
        <p-select
          inputId="settings-person-role"
          [options]="roles"
          formControlName="role"
          appendTo="body"
        >
          <ng-template #item let-option>{{
            option.label | translate
          }}</ng-template>
          <ng-template #selectedItem let-option>{{
            option.label | translate
          }}</ng-template>
        </p-select>
      </div>
      <p class="text-muted person-full">
        {{ "BUSINESS_SETTINGS.LOGIN_ROLE_HINT" | translate }}
      </p>
      <div class="person-full">
        <app-password-validator
          (passwordChange)="password = $event"
          (validChange)="passwordValid = $event"
        />
      </div>
    </div>
  </form>
  <ng-template #footer>
    <div class="person-actions">
      <button
        type="button"
        pButton
        [outlined]="true"
        [disabled]="saving"
        (click)="closed.emit()"
      >
        {{ "CANCEL" | translate }}
      </button>
      <button
        type="submit"
        form="settings-person-form"
        pButton
        [disabled]="
          loading ||
          saving ||
          form.invalid ||
          (form.controls.createLogin.value && !passwordValid)
        "
      >
        {{
          (saving ? "SAVE_PROCESS" : "BUSINESS_SETTINGS.CREATE_PERSON")
            | translate
        }}
      </button>
    </div>
  </ng-template>
</p-dialog>
